import { render, staticRenderFns } from "./main-producing.vue?vue&type=template&id=4be11551&scoped=true&"
import script from "./main-producing.vue?vue&type=script&lang=js&"
export * from "./main-producing.vue?vue&type=script&lang=js&"
import style0 from "./main-producing.vue?vue&type=style&index=0&id=4be11551&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be11551",
  null
  
)

export default component.exports